import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Defensive wrapper: some browser extensions or injected scripts call
// MutationObserver.prototype.observe with non-Node targets which throws
// in modern browsers. Wrap the original to silently ignore invalid targets
// and avoid breaking the app. This runs early (before Angular bootstraps).
// Only run in browser context (SSR guard)
if (typeof window !== 'undefined' && typeof MutationObserver !== 'undefined') {
  (function initMutationObserverGuard() {
    try {
      const orig = MutationObserver.prototype.observe as (target: Node, options?: any) => void;
      MutationObserver.prototype.observe = function (target: Node, options?: any) {
        // Basic check: target must be a Node with a numeric nodeType
        if (!target || typeof (target as Node).nodeType !== 'number') {
          // Avoid noisy errors but keep a lightweight warning for debugging
          if (console && console.warn) {
            console.warn('MutationObserver.observe skipped: target is not a Node', target);
          }
          return;
        }
        return orig.call(this, target, options);
      };
    } catch (e) {
      // If MutationObserver isn't available or we can't monkey-patch, continue silently
      if (console && console.warn) {
        console.warn('Could not install MutationObserver guard', e);
      }
    }
  })();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));

// Register built-in scanner connectors for BYOS mode at app startup
import { registerBuiltInConnectors } from './app/services/connectors/registry.bootstrap';
try {
  registerBuiltInConnectors();
} catch (e) {
  console.error('Failed to register built-in connectors', e);
  throw e instanceof Error ? e : new Error(String(e));
}
